/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import { combineCodec, getEnumDecoder, getEnumEncoder } from "@solana/kit";

export enum AccountsType {
  TransferHookA = 0,
  TransferHookB = 1,
  TransferHookReward = 2,
  TransferHookInput = 3,
  TransferHookIntermediate = 4,
  TransferHookOutput = 5,
  SupplementalTickArrays = 6,
  SupplementalTickArraysOne = 7,
  SupplementalTickArraysTwo = 8,
}

export type AccountsTypeArgs = AccountsType;

export function getAccountsTypeEncoder(): FixedSizeEncoder<AccountsTypeArgs> {
  return getEnumEncoder(AccountsType);
}

export function getAccountsTypeDecoder(): FixedSizeDecoder<AccountsType> {
  return getEnumDecoder(AccountsType);
}

export function getAccountsTypeCodec(): FixedSizeCodec<
  AccountsTypeArgs,
  AccountsType
> {
  return combineCodec(getAccountsTypeEncoder(), getAccountsTypeDecoder());
}
